import { quoteCaption, quoteCaptionContainer } from './QuoteCaption.css';
import type { PostQuoteCaptionProps } from './QuoteCaption.types';

export const PostQuoteCaption = ({ children }: PostQuoteCaptionProps) => {
  if (!children || (Array.isArray(children) && children.length === 0)) {
    return null;
  }

  return (
    <div className={quoteCaptionContainer}>
      <small className={quoteCaption}>{children}</small>
    </div>
  );
};
